<template>
  <transition name="fade">
    <div v-show="scrollPosition > 200" @click="scrollToTop" class="goTopBtn">
      &#10140;
    </div>
  </transition>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "GoTop",
  computed: {
    // Mappe die scrollPosition aus dem Vuex-Store
    ...mapState({
      scrollPosition: (state) => state.scrollPosition,
    }),
  },
  methods: {
    scrollToTop() {
      // Verwende hier das Verhalten, das in der Router-Datei vorhanden ist
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style lang="sass">
@import '@/assets/sass/main.sass'
.goTopBtn
  position: fixed
  z-index: 20
  display: block
  bottom: 2.5rem
  right: 2rem
  background-color: $gold
  color: white
  border: none
  padding: .7rem 1rem
  font-size: 1.2rem
  cursor: pointer
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3)
  transition: 0.8s
  transform: rotate(-90deg)
  &:hover
    background-color: darken($gold, 10%)
    color: lighten($gold, 35%)
</style>
